/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SsoGroupMapping
 */
export interface SsoGroupMapping {
    /**
     * 
     */
    user_role_id?: string;
    /**
     * 
     */
    home_facility_id?: string;
    /**
     * 
     */
    system_permissions?: Array<string>;
    /**
     * 
     */
    staff_group_ids?: Array<string>;
    /**
     * 
     */
    additional_facility_ids?: Array<string>;
    /**
     * 
     */
    idp_group_id: string;
}

/**
 * Check if a given object implements the SsoGroupMapping interface.
 */
export function instanceOfSsoGroupMapping(value: object): value is SsoGroupMapping {
    if (!('idp_group_id' in value) || value['idp_group_id'] === undefined) return false;
    return true;
}

export function SsoGroupMappingFromJSON(json: any): SsoGroupMapping {
    return SsoGroupMappingFromJSONTyped(json, false);
}

export function SsoGroupMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): SsoGroupMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'user_role_id': json['user_role_id'] == null ? undefined : json['user_role_id'],
        'home_facility_id': json['home_facility_id'] == null ? undefined : json['home_facility_id'],
        'system_permissions': json['system_permissions'] == null ? undefined : json['system_permissions'],
        'staff_group_ids': json['staff_group_ids'] == null ? undefined : json['staff_group_ids'],
        'additional_facility_ids': json['additional_facility_ids'] == null ? undefined : json['additional_facility_ids'],
        'idp_group_id': json['idp_group_id'],
    };
}

export function SsoGroupMappingToJSON(json: any): SsoGroupMapping {
    return SsoGroupMappingToJSONTyped(json, false);
}

export function SsoGroupMappingToJSONTyped(value?: SsoGroupMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_role_id': value['user_role_id'],
        'home_facility_id': value['home_facility_id'],
        'system_permissions': value['system_permissions'],
        'staff_group_ids': value['staff_group_ids'],
        'additional_facility_ids': value['additional_facility_ids'],
        'idp_group_id': value['idp_group_id'],
    };
}

